/* Copyright 2015 The MathWorks, Inc. */

/**
 * This module defines the mapping between the event name as expected by the UIBuilder public API and the actual event
 * emitted by the widget.
 */

define([
    "../constants/TypeConstants"
], function (TypeConstants) {
    var hash = {};

    hash[TypeConstants.PUSH_BUTTON] = {
        buttonPushed: "click"
    };

    hash[TypeConstants.DROP_DOWN_BUTTON] = {
        dropDownPerformed: "dropdownclick"
    };

    hash[TypeConstants.SPLIT_BUTTON] = {
        dropDownPerformed: "dropdownclick",
        buttonPushed: "click"
    };

    hash[TypeConstants.COLOR_PICKER_BUTTON] = {
        valueChanged: "change"
    };

    hash[TypeConstants.TOGGLE_SPLIT_BUTTON] = {
        dropDownPerformed: "dropdownclick"
    };

    hash[TypeConstants.QAB_PUSH_BUTTON] = hash[TypeConstants.PUSH_BUTTON];

    hash[TypeConstants.QAB_DROP_DOWN_BUTTON] = hash[TypeConstants.DROP_DOWN_BUTTON];

    hash[TypeConstants.QAB_SPLIT_BUTTON] = hash[TypeConstants.SPLIT_BUTTON];

    hash[TypeConstants.QAB_TOGGLE_SPLIT_BUTTON] = hash[TypeConstants.TOGGLE_SPLIT_BUTTON];

    hash[TypeConstants.TEXT_FIELD] = {
        focusGained: "focusgained",
        focusLost: "focuslost",
        typing: "typing",
        textCancelled: "textcancelled"
    };

    hash[TypeConstants.TEXT_AREA] = {
        focusGained: "focusgained",
        focusLost: "focuslost"
    };

    hash[TypeConstants.COMBO_BOX] = {
        focusGained: "focus",
        focusLost: "blur",
        typing: "typing",
        textCancelled: "textcancelled",
        dropDownPerformed: "dropdownclick"
    };

    hash[TypeConstants.POPUP_LIST] = {
        onOpen: "open",
        onClose: "close"
    };


    hash[TypeConstants.SPINNER] = {
        valueChanged: "change"
    };

    hash[TypeConstants.LIST_ITEM] = {
        itemPushed: "click"
    };

    hash[TypeConstants.LIST_ITEM_WITH_TEXTFIELD] = {
        focusGained: "focusgained",
        focusLost: "focuslost",
        typing: "typing",
        commit: "commit",
        recommit: "recommit",
        textCancelled: "textcancelled",
        itemPushed: "itempushed"
    };

    hash[TypeConstants.LIST_ITEM_WITH_POPUP] = {
        dropDownPerformed: "dropdownclick"
    };

    hash[TypeConstants.LIST_ITEM_WITH_CHECKBOX] = {
        closeRequest: "closeRequest"
    };

    return hash;
});
